import { combineReducers } from '@reduxjs/toolkit';
import * as enquiry from './enquiry';
import * as quote from './quote';
import * as shortlist from './shortlist';
const rootReducer = combineReducers({
    [shortlist.name]: shortlist.reducer,
    [enquiry.name]: enquiry.reducer,
    [quote.name]: quote.reducer,
});
export default rootReducer;
